let tags = {
  bank_account: 'ACH',
  credit_card: 'CC',
  in_office: 'In Office',
}
export function formatTag(tag) {
  return tags?.[tag] || tag
}
